import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { personDisplayName } from 'components/helpers/users';

export default function SendInvitationModal({
  isOpen,
  onClose,
  onSendConfirmationClick,
  personnel,
  user,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.SendInvitationModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  if (!personnel || !user) return null;

  const isUserAlreadyInvited = user.attributes.invitationStatus !== 'none';

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onSendConfirmationClick}>
            {isUserAlreadyInvited ? i18nTShared('resend') : i18nTShared('send')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nT(
              `title.${isUserAlreadyInvited ? 'alreadyInvited' : 'default'}`,
              {
                interpolation: { escapeValue: false },
                name: personDisplayName({ attributes: personnel.attributes }),
              },
            )}
          </h2>
        </div>
        <div className='modalbox-body'>
          {i18nT(
            `description.${isUserAlreadyInvited ? 'alreadyInvited' : 'default'}`,
            {
              email: personnel.attributes.email,
              interpolation: { escapeValue: false },
            },
          )}
        </div>
      </>
    </ModalBox>
  );
}

SendInvitationModal.propsTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  personnel: PropTypes.object.isRequired,
  onSendConfirmationClick: PropTypes.func.isRequired,
};
